var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[(_vm.options)?_c('highcharts',{ref:"featureChart",attrs:{"options":_vm.options}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }